/**
 * NewMessageDivider — Slack-style "NEW" separator shown above the first message
 * the viewer hasn't seen: a thin red line spanning the width with the "NEW"
 * label on the right.
 *
 * Shared by the game chat and the secret-message threads (both via
 * MessageThread). Stays put until `dismissed` flips true (the viewer focuses
 * the composer / leaves), then fades out over 400ms — WITHOUT collapsing, so
 * the messages below never jump.
 *
 * Inline styles (not NativeWind classes) on purpose: flex/bg classNames don't
 * apply reliably to an Animated.View, which silently dropped the red line.
 */
import React from 'react'
import { NewMessageDivider as Divider } from '../../../../packages/ui/src/components/NewMessageDivider'
import { useTheme } from '../../hooks/useTheme'

export function NewMessageDivider({ dismissed }: { dismissed: boolean }) {
  const { theme } = useTheme()
  // `blood` is theme-aware (global.css): keep the divider in sync.
  const bloodHex = theme === 'dark' ? '#e0463f' : '#a01818'
  return <Divider dismissed={dismissed} color={bloodHex} />
}
